export const userWebsitePaths = {
    whatsApp: "https://api.whatsapp.com/send/?phone=919822081133&text&type=phone_number&app_absent=0",
    linkIcon: "https://www.linkedin.com/in/emediskill-services-579773282/'",
    instagramIcon: "https://www.instagram.com/emediskill/?next=%2F&hl=en'",
    facebookIcon: "https://www.facebook.com/emediskill/'",
    whatsappIcon: "https://api.whatsapp.com/send/?phone=919822081133&text&type=phone_number&app_absent=0'",
    twitterIcon: "https://x.com/emediskill'",
    youTubeIcon: "https://www.youtube.com/@eMediSkill'",
    telegramIcon: "https://t.me/eMediSkill'",
    termsOfService: "/articles/terms-of-service",
    a_privacyPolicy: "/articles/privacy-policy",
    about: "/about",
    getApp: "#",
    login: "/login",
    myLearning: "/my-learning",
    customerCare: "/contact",
    offers: "/offers",
    explore: "/explore",
} as const